export const COURSE_GRADE_TYPE = {
  ATTENDANCE_RATE: 'attendanceRate',
  EXAMINATION_RATE: 'examinationRate',
  EXAMINATION_AVERAGE_RESULT: 'examinationAverageResult',
  GROWTH_RATE: 'growthRate',
  MASTERY: 'mastery',
};

export const COURSE_GRADE_TYPE_REVERSE = {
  attendanceRate: 'ATTENDANCE_RATE',
  examinationRate: 'EXAMINATION_RATE',
  examinationAverageResult: 'EXAMINATION_AVERAGE_RESULT',
  growthRate: 'GROWTH_RATE',
  mastery: 'MASTERY',
};

export const COURSE_GRADE_STAT_TYPE = {
  AVERAGE: 'average',
  MAX: 'max',
  MIN: 'min',
  MEDIAN: 'median',
};

export const COURSE_GRADE_STAT_TYPE_REVERSE = {
  average: 'AVERAGE',
  max: 'MAX',
  min: 'MIN',
  median: 'MEDIAN',
};
